module.exports = __webpack_public_path__ + "img/470.1d63727f.jpg";